import React, { FC } from 'react'

import { WrappedFieldProps, change } from 'redux-form'

import { Box } from '@material-ui/core'
import { ChevronRight } from '@material-ui/icons'

import ListBox from '~/components/shared/ListBox/ListBox'
import ListBoxItem from '~/components/shared/ListBox/ListBoxItem'
import { ListBoxProps } from '~/components/shared/ListBox/types'
import Text from '~/components/shared/Text'

import EmpriseGroup from '~/services/EmpriseGroup'

import theme from '~/theme'

import { getListItemTextPrimary } from './categoryFilter.helpers'
import { useCategoryFilterFieldStyles } from './CategoryFilterField.styles'

interface CategoryFilterFieldProps {
  onClick?: () => void
}

type Props = ListBoxProps & WrappedFieldProps & CategoryFilterFieldProps

const CategoryFilterField: FC<Props> = ({
  input: { onChange, ...input },
  meta: { dispatch, form },
  onClick
}) => {
  const classes = useCategoryFilterFieldStyles()

  const handleChange = (value, reason) => {
    onChange(value)

    const reasons = ['remove-option']
    if (reasons.includes(reason)) {
      dispatch(change(form, 'by_type', null))
    }
  }

  const handleClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
    onClick && onClick()
  }

  return (
    <div className={classes.root}>
      <Text
        variant="h3"
        mb={3}
        fontFamily="Prompt, sans-serif"
        fontWeight={500}
      >
        Select Category
      </Text>

      <ListBox
        key={input.name}
        {...input}
        optionSettings={{
          key: 'product_categories',
          loadOptions: async () => {
            const options = await EmpriseGroup.getMainCategories()
            const normalized = options.map((option) => ({ ...option }))
            return normalized
          },
          optionValue: 'name',
          optionLabel: 'name'
        }}
        onChange={handleChange}
        hideSearch
        renderOption={({ option, selected }) => {
          const primary = getListItemTextPrimary(option)

          return (
            <>
              <ListBoxItem
                primary={primary}
                option={option}
                selected={selected}
                onChange={handleChange}
                hideCheckbox
                rightAdornment={
                  selected && (
                    <Box
                      display="flex"
                      alignItems="center"
                      onClick={(e) => handleClick(e)}
                    >
                      <Text
                        ml={1.5}
                        style={{ color: theme.palette.primary.main }}
                      >
                        Sub category
                      </Text>

                      <ChevronRight
                        style={{ color: theme.palette.primary.main }}
                        width={7}
                        height={12}
                      />
                    </Box>
                  )
                }
              />
            </>
          )
        }}
      />
    </div>
  )
}

export default CategoryFilterField
